import { Injectable } from "@angular/core";
import { Socket } from "ngx-socket-io";
import { environment } from "@environments/environment";
import { AuthServiceImpl } from "@app/shared/authentication/services/auth.servcice";
import { IChatMessage, ISendChatMessageDtoInput } from "@app/shared/chat/interfaces/chat-message.interface";
import { IUnresolvedConversation } from "@app/shared/chat/interfaces/conversation.interface";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ChatSocketService extends Socket {
  readonly messageSent$ = new Subject<{ conversationId: string; message: IChatMessage }>();

  constructor(authService: AuthServiceImpl) {
    super({
      url: environment.CHAT_SOCKET_URL,
      options: {
        transports: ["websocket"],
        path: "/socket.io/",
        auth: { token: `Bearer ${authService.getToken()}` },
        withCredentials: true,
      },
    });
  }

  async sendChatMessage(input: ISendChatMessageDtoInput) {
    const ack = await this.emitWithAck<{ result: IChatMessage }>("sendConversationMessage", input);
    this.messageSent$.next({ conversationId: input.targetSwapRequestId, message: ack.result });
    return ack;
  }

  markMessagesAsSeen(swapRequestId: string) {
    return this.emitWithAck<{ result: IChatMessage }>("markMessagesAsSeen", { swapRequestId });
  }

  observerChatMessagesEvent() {
    return this.fromEvent<{ conversation: IUnresolvedConversation; message: IChatMessage }>("conversationMessage");
  }
}
